/**
 * @flow
 * Created by neo on 28.05.17.
 */
import React, { Component } from 'react';
import { observable } from 'mobx';
import {observer} from 'mobx-react';
import * as mobx from 'mobx';
import { SingleDatePicker } from 'react-dates';
import 'moment/locale/de-ch';
import FlightOfferAvailability from '../../../Store/FlightOffer/FlightOfferAvailability';
import moment from 'moment-timezone';

type Props = {
  availability: FlightOfferAvailability,
  onDateChanged: (date: any) => void,
  onMonthChanged: (startDate: any, endDate: any) => void,
  fullscreen?: boolean
};

@observer
export default class DatePicker extends React.Component<Props, void> {
  
  @observable availability: FlightOfferAvailability = new FlightOfferAvailability();
  @observable date: any = null;
  @observable focused: boolean = false;
  @observable currentDate: any = moment();

  static defaultProps = {
    fullscreen: false
  };
  
  componentWillReceiveProps(nextProps: Props) {
    if (this.availabilty !== nextProps.availability) {
      this.availability =  new FlightOfferAvailability(nextProps.availability);
    }
  }

  handleDateChanged = (date: any) => {
    if (this.date !== date) {
      this.date = date;
      this.props.onDateChanged(date);
    }
  };

  handlePrevMonthClick = () => {
    const currentDate = moment(this.currentDate).subtract(1, 'months');
    const startDate = moment(currentDate).startOf('month');
    const endDate = moment(currentDate).endOf('month');
    this.props.onMonthChanged(startDate, endDate);
    this.currentDate = currentDate;
  };

  handleNextMonthClick = () => {
    const currentDate = moment(this.currentDate).add(1, 'months');
    const startDate = moment(currentDate).startOf('month');
    const endDate = moment(currentDate).endOf('month');
    this.props.onMonthChanged(startDate, endDate);
    this.currentDate = currentDate;
  };
  
  handleFocused = ({ focused }: any) => this.focused = focused;

  getCurrentDate = () => {
    this.props.onMonthChanged(
      this.currentDate.startOf('month'),
      this.currentDate.endOf('month')
    );

    return this.currentDate;
  };

  render() {
    const { availability, date, focused, props: { fullscreen } } = this;
    const isDayBlocked = (date: any) => {
      const today = moment();
      const diff = today.diff(date, 'days');

      if(diff <= 0) {
        if(this.availability) {
          const format = date.format('YYYY-MM-DD');
          return !this.availability.dates || this.availability.dates.indexOf(format) === -1;
        }
      }

      return true;
    };
    return (
      <SingleDatePicker
        id="date_input"
        date={date}
        focused={focused}
        numberOfMonths={1}
        isDayBlocked={isDayBlocked}
        onDateChange={this.handleDateChanged}
        onFocusChange={this.handleFocused}
        onNextMonthClick={this.handleNextMonthClick}
        onPrevMonthClick={this.handlePrevMonthClick}
        withFullScreenPortal={fullscreen}
        initialVisibleMonth={this.getCurrentDate}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/Booking/DatePicker.js